import { render } from "./DocumentFieldUrl.vue?vue&type=template&id=1a76ce86&scoped=true"
import script from "./DocumentFieldUrl.vue?vue&type=script&lang=js"
export * from "./DocumentFieldUrl.vue?vue&type=script&lang=js"

import "./DocumentFieldUrl.vue?vue&type=style&index=0&id=1a76ce86&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a76ce86"]])

export default __exports__